import { isUserActive } from '@esentai/core/features/users/selectors';
import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import UserActivity from './component';
import styles from './styles';

const mapStateToProps = (state, { userId }) => ({
  active: isUserActive(state, userId),
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(UserActivity);
